import { render, staticRenderFns } from "./CommChannel.vue?vue&type=template&id=5a268d12&"
import script from "./CommChannel.vue?vue&type=script&lang=js&"
export * from "./CommChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports